export default __webpack_public_path__ + "static/media/procedencia.8d648ad9.png";